import { Link, useLocation } from "react-router-dom";
import { MessageCircleQuestion } from "lucide-react";

export default function DoubtFab() {
  const loc = useLocation();
  // Don't show FAB on auth or doubt chat page itself
  if (loc.pathname === "/auth" || loc.pathname === "/study/chat") return null;
  return (
    <Link
      to="/study/chat"
      data-testid="fab-doubt"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-black text-white px-5 py-3 rounded-full nb-border nb-shadow-lg nb-hover-lg font-heading font-bold uppercase text-xs tracking-tight"
    >
      <MessageCircleQuestion className="w-5 h-5" />
      Ask a doubt
    </Link>
  );
}
